import React, { useState, useEffect, useMemo } from "react";
import { connect } from "react-redux";
import { fetch, fetchLocalAgent, setCaixa, resetDadoPesq } from "../../actions";
import { ModalPadrao, LabelPadrao, InputPadrao, LoadingContainerPadrao, TextAreaPadrao, SemDados } from "../../components/Base";
import { Input, Divider, Tag } from "antd";
import { InputNumero } from "../../components/InputNumero";
import { useFetch, useSave } from "../../components/Hooks/Conexao";
import Mensagens from "../../components/Mensagens";
import toLocale from "../../Utils/ToLocaleString";
import { BtnGravar, BtnPadrao, BtnSair } from "../../components/Buttons";
import culture from "../../Utils/Culture";
import InputBlur from "../../components/InputBlur";
import { imprimirRetorno } from "../../Utils/impressaoUtils";

const minHeight = 300;

function AbrirFecharCaixa({ onOk, visible, ...props }) {
  const [dados, listarDados, loading, setDados] = useFetch(() => props.fetch().post("/caixa/get"), {}, {});
  const [obs, setObs] = useState();
  const [save, saving] = useSave();

  const permiteAcessarMovimentos = !props.dados?.parametros ? false : props.dados.parametros["PermiteAcessarMovimentos"];

  useEffect(() => { if (visible) listarDados(); }, [visible]);

  const inputObs = <TextAreaPadrao style={{ marginTop: 25 }} value={obs} onChange={v => setObs(v.target.value)} placeholder="Observação" />;

  return <ModalPadrao
    visible={visible}
    onCancel={() => saving ? {} : onOk()}
    closable={!saving}
    title={dados?.id != 0 ? "Fechar caixa" : "Abrir caixa"}
    width={600}
    footer={null}>
    <LoadingContainerPadrao style={{ minHeight }} loading={loading || saving}>
      {dados?.id == 0 ?
        <Abrir
          dados={dados}
          setDados={setDados}
          onOk={() => save(() => props.fetch().post("/caixa/abrir", { ...dados, obs }), () => { Mensagens.showSucesso("Caixa aberto com sucesso!"); onOk(); props.setCaixa(true); setObs(null); })}
          loading={saving}
        >{inputObs}</Abrir> :
        <Fechar
          permiteAcessarMovimentos={permiteAcessarMovimentos}
          dados={dados}
          setDados={setDados}
          onOk={() => save(() => props.fetch().post("/caixa/fechar", { ...dados, obs, totais: dados.totais.filter(x => x.modalidadeId > 0) }), v => {
            Mensagens.showSucesso("Caixa fechado com sucesso!");
            onOk();
            props.setCaixa(false);
            props.resetDadoPesq("caixa");
            setObs(null);
            imprimirRetorno(props.fetchLocalAgent, v);
          })}
          loading={saving}
          onCancel={onOk}
          fetch={props.fetch}
        >{inputObs}</Fechar>}

    </LoadingContainerPadrao>
  </ModalPadrao>;
}

const mapStateToProps = state => ({ dados: state.dados });

export default connect(mapStateToProps, { fetch, fetchLocalAgent, setCaixa, resetDadoPesq })(AbrirFecharCaixa);

function Abrir({ dados, setDados, onOk, loading, ...props }) {
  const [visible, setVisible] = useState(false);

  if (!dados)
    return <></>;

  return <>
    <div style={{ minHeight }}>
      <div style={{ display: "flex", alignItems: "flex-end" }}>
        <div style={{ marginRight: 10, width: "50%" }}>
          <LabelPadrao noMargin>Operador</LabelPadrao>
          <InputPadrao value={dados.operador} disabled />
        </div>
        <Tag color="#d62400" style={{ width: "50%", fontSize: 14, padding: 5, textAlign: "center" }}>FECHADO</Tag>
      </div>
      <Divider orientation="left">Fundo de caixa </Divider>
      <div style={{ display: "flex", alignItems: "flex-end" }}>
        <div style={{ width: "50%", marginRight: 10 }}>
          <LabelPadrao noMargin>Anterior</LabelPadrao>
          <InputNumero style={{ width: "100%" }} value={dados.fundoInicial} disabled />
        </div>
        <div style={{ width: "50%" }}>
          <LabelPadrao noMargin>Inicial</LabelPadrao>
          <InputNumero min={0} style={{ width: "100%" }} value={dados.fundoCaixa} onChange={v => setDados({ ...dados, fundoCaixa: v })} />
        </div>
      </div>
      {props.children}
    </div>

    <div style={{ display: "flex", justifyContent: "flex-end" }}>
      <BtnPadrao loading={loading} onClick={() => dados.fundoCaixa != dados.fundoInicial ? setVisible(true) : onOk()}>Abrir</BtnPadrao>
    </div>

    <ModalMotivo
      visible={visible}
      onOk={() => { onOk(); setVisible(false); }}
      onCancel={() => setVisible(false)}
      title="Divergência de valores">
      <p>Valor inicial de fundo de caixa difere do valor inicial informado, para continuar com a abertura informe o motivo.</p>
    </ModalMotivo>
  </>;
}

function Fechar({ dados, setDados, onCancel, onOk, loading, fetch, permiteAcessarMovimentos, ...props }) {
  const [proximo, setProximo] = useState(true);

  if (!dados)
    return <></>;

  return <>
    <div style={{ minHeight }}>
      {proximo ? <>
        <div style={{ display: "flex", alignItems: "flex-end" }}>
          <div style={{ marginRight: 10, width: "50%" }}>
            <LabelPadrao noMargin>Operador</LabelPadrao>
            <InputPadrao value={dados.operador} disabled />
          </div>
          <Tag color="#7dd600" style={{ width: "50%", fontSize: 14, padding: 5, textAlign: "center", margin: 0 }}>Aberto</Tag>
        </div>
        <Divider orientation="left">Valores no caixa para Fechamento</Divider>
        {/* <TabelaPadrao columns={columns} data={dados.totais} /> */}
        {dados.totais?.length ? <table className="tabela-padrao" style={{ marginTop: 10 }}>
          <thead>
            <th style={{ textAlign: "initial" }}>Modalidade</th>
            <th style={{ textAlign: "right" }}>Valor computado</th>
            <th style={{ textAlign: "right" }}>Valor em caixa</th>
          </thead>

          <tbody >
            {dados.totais?.map((x, inx) => <tr key={x.id} >
              <td style={{ textAlign: "initial" }}>{x.nome}</td>
              <td style={{ textAlign: "right" }}>R$ {culture.format(x.recebido)}</td>
              <td style={{ textAlign: "right" }}><InputBlur style={{ width: 150 }} min={0} value={x.valorComputado} onChange={v => {
                const aux = [...dados.totais];
                aux[aux.findIndex(s => s.modalidadeId == x.modalidadeId)].valorComputado = v;
                setDados({ ...dados, totais: aux });
              }} tabIndex={500 + inx} /></td>
            </tr>)}
          </tbody>

          <tfoot>
            <td style={{ textAlign: "initial" }}></td>
            <td style={{ textAlign: "right" }}>{`R$ ${culture.format(dados?.totais?.reduce((a, b) => a + b.recebido, 0))}`}</td>
            <td style={{ textAlign: "right" }}>{`R$ ${culture.format(dados?.totais?.reduce((a, b) => a + b.valorComputado, 0))}`}</td>
          </tfoot>
        </table> : <SemDados />}
      </> :
        <>
          <div style={{ display: "flex", alignItems: "flex-end" }}>
            <div style={{ width: "50%", marginRight: 10 }}>
              <LabelPadrao noMargin>Operador</LabelPadrao>
              <InputPadrao value={dados.operador} disabled />
            </div>
            <Tag color="#7dd600" style={{ width: "50%", fontSize: 14, padding: 5, textAlign: "center", margin: 0 }}>Aberto</Tag>
          </div>

          <Divider orientation="left">Valores no caixa para Fechamento</Divider>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <div style={{ marginRight: 10 }}>
              <LabelPadrao noMargin>Fundo inicial</LabelPadrao>
              <InputNumero value={dados.fundoInicial} style={{ width: "100%" }} disabled />
            </div>
            <div>
              <LabelPadrao noMargin>Fundo caixa</LabelPadrao>
              <InputNumero min={0} value={dados.fundoCaixa} style={{ width: "100%" }} onChange={v => setDados({ ...dados, fundoCaixa: v })} />
            </div>
          </div>
          <Divider style={{ marginTop: 20 }} orientation="left">Conferência de valores para fechamento</Divider>
          {dados.totais.length ? dados.totais?.map((x, inx) => <p key={inx}>{x.nome} {toLocale(x.valorComputado)}</p>) : <SemDados text="Sem valores em caixa" />}
          {props.children}
        </>}

    </div>
    {proximo ? <div style={{ width: "100%", display: "flex", justifyContent: "flex-end", marginTop: 25 }}>
      <BtnPadrao onClick={() => setProximo(false)} style={{ marginRight: 10 }}>Próximo</BtnPadrao>
      <BtnSair onClick={onCancel} />
    </div>
      : <div style={{ width: "100%", display: "flex", justifyContent: "space-between", marginTop: 25 }}>
        <BtnPadrao onClick={() => setProximo(true)} style={{ marginRight: 10 }}>Voltar</BtnPadrao>
        <div>
          <BtnPadrao onClick={onOk} loading={loading} style={{ marginRight: 10 }}>Fechar</BtnPadrao>
          <BtnSair onClick={onCancel} disabled={loading} />
        </div>
      </div>}
  </>;
}

function ModalMotivo({ visible, onOk, onCancel, title, ...props }) {
  return <ModalPadrao
    visible={visible}
    onCancel={onCancel}
    title={title}
    footer={
      <>
        <BtnGravar onClick={() => onOk()} />
        <BtnSair onClick={onCancel} />
      </>}>
    <LabelPadrao noMargin style={{ textAlign: "center" }}>{props.children}</LabelPadrao>
  </ModalPadrao>;
}
